import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common from '../locales/es/common.json';
import dashboard from '../locales/es/dashboard.json';
import users from '../locales/es/users.json';
import admins from '../locales/es/admins.json';
import subscriptions from '../locales/es/subscriptions.json';
import licenses from '../locales/es/licenses.json';
import audit from '../locales/es/audit.json';
import system from '../locales/es/system.json';
import settings from '../locales/es/settings.json';

i18n.use(initReactI18next).init({
  lng: 'es',
  fallbackLng: 'es',
  ns: ['common', 'dashboard', 'users', 'admins', 'subscriptions', 'licenses', 'audit', 'system', 'settings'],
  defaultNS: 'common',
  resources: {
    es: { common, dashboard, users, admins, subscriptions, licenses, audit, system, settings },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
